// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"760":"b252567e","787":"32dd219a"}[chunkId] + ".chunk.js";
};